import { render } from "./OptionEditor.vue?vue&type=template&id=48e3b324&scoped=true"
import script from "./OptionEditor.vue?vue&type=script&lang=js"
export * from "./OptionEditor.vue?vue&type=script&lang=js"

import "./OptionEditor.vue?vue&type=style&index=0&id=48e3b324&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e3b324"]])

export default __exports__